export default {
  getIconClassById: (iconId) => {
    let iconObj = iconsDictionary.find((x) => x.id === iconId)
    if (!iconObj) {
      console.error('can`t find the icon by id: ' + iconId)
    }
    return iconObj ? iconObj.className : null
  }
}

let iconsDictionary = [
  { id: 97, className: 'dbc-icon dbc-icon-home' },
  { id: 98, className: 'dbc-icon dbc-icon-user-voice' },
  { id: 99, className: 'dbc-icon dbc-icon-card-account-phone' },
  { id: 100, className: 'dbc-icon dbc-icon-message' },
  { id: 101, className: 'dbc-icon dbc-icon-email' },
  { id: 102, className: 'dbc-icon dbc-icon-phone-call' },
  { id: 103, className: 'dbc-icon dbc-icon-video' },
  { id: 104, className: 'dbc-icon dbc-icon-info' },
  { id: 105, className: 'dbc-icon dbc-icon-businessman' },
  { id: 106, className: 'dbc-icon dbc-icon-facebook' },
  { id: 107, className: 'dbc-icon dbc-icon-perm-media' },
  { id: 108, className: 'dbc-icon dbc-icon-article' },
  { id: 109, className: 'dbc-icon dbc-icon-star' },
  { id: 110, className: 'dbc-icon dbc-icon-business' },
  { id: 111, className: 'dbc-icon dbc-icon-info' },
  { id: 112, className: 'dbc-icon dbc-icon-people-team' },
  { id: 113, className: 'dbc-icon dbc-icon-video' },
  { id: 114, className: 'dbc-icon dbc-icon-location' },
  { id: 115, className: 'dbc-icon dbc-icon-users-three' },
  { id: 116, className: 'dbc-icon dbc-icon-share' },
  { id: 117, className: 'dbc-icon dbc-icon-user-friends' },
  { id: 118, className: 'dbc-icon dbc-icon-map_car-dealer' },
  { id: 119, className: 'dbc-icon dbc-icon-receipt' },
  { id: 120, className: 'dbc-icon dbc-icon-calculator' },
  { id: 121, className: 'dbc-icon dbc-icon-document-header' },
  { id: 122, className: 'dbc-icon dbc-icon-solid_car' },
  { id: 123, className: 'dbc-icon dbc-icon-car-mechanic-1' },
  { id: 124, className: 'dbc-icon dbc-icon-car-mechanic-2' },
  { id: 125, className: 'dbc-icon dbc-icon-book' },
  { id: 126, className: 'dbc-icon dbc-icon-car-mechanic' },
  { id: 127, className: 'dbc-icon dbc-icon-user' },
  { id: 128, className: 'dbc-icon dbc-icon-smartphone-download' },

  { id: 129, className: 'dbc-icon dbc-icon-linkedin' },
  { id: 130, className: 'dbc-icon dbc-icon-twitter' },
  { id: 131, className: 'dbc-icon dbc-icon-calculator' },
  { id: 132, className: 'dbc-icon dbc-icon-home' },
  { id: 133, className: 'dbc-icon dbc-icon-message' },
  { id: 134, className: 'dbc-icon dbc-icon-star' },
  { id: 135, className: 'dbc-icon dbc-icon-facebook' },
  { id: 136, className: 'dbc-icon dbc-icon-bar-graph' },
  { id: 137, className: 'dbc-icon dbc-icon-book' },
  { id: 138, className: 'dbc-icon dbc-icon-business' },
  { id: 139, className: 'dbc-icon dbc-icon-calendar-check' },
  { id: 140, className: 'dbc-icon dbc-icon-calendar-plus' },
  { id: 141, className: 'dbc-icon dbc-icon-calendar' },
  { id: 142, className: 'dbc-icon dbc-icon-car-mechanic-1' },
  { id: 143, className: 'dbc-icon dbc-icon-car-mechanic-2' },
  { id: 144, className: 'dbc-icon dbc-icon-car-mechanic' },
  { id: 145, className: 'dbc-icon dbc-icon-message' },
  { id: 146, className: 'dbc-icon dbc-icon-offer' },
  { id: 147, className: 'dbc-icon dbc-icon-right-top-arrow-circle' },
  { id: 148, className: 'dbc-icon dbc-icon-user-voice' },
  { id: 149, className: 'dbc-icon dbc-icon-user' },
  { id: 150, className: 'dbc-icon dbc-icon-location' },
  { id: 151, className: 'dbc-icon dbc-icon-settings-filled' },
  { id: 152, className: 'dbc-icon dbc-icon-businessman' },
  { id: 153, className: 'dbc-icon dbc-icon-format-chat' },
  { id: 154, className: 'dbc-icon dbc-icon-lock' },
  { id: 155, className: 'dbc-icon dbc-icon-credit' },
  { id: 156, className: 'dbc-icon dbc-icon-info' },
  { id: 157, className: 'dbc-icon dbc-icon-phone-call' },
  { id: 158, className: 'dbc-icon dbc-icon-video' },
  { id: 159, className: 'dbc-icon dbc-icon-car' },
  { id: 160, className: 'dbc-icon dbc-icon-link' },
  { id: 161, className: 'dbc-icon dbc-icon-share-alt' },
  { id: 162, className: 'dbc-icon dbc-icon-share' },
  { id: 163, className: 'dbc-icon dbc-icon-user-friends' },
  { id: 164, className: 'dbc-icon dbc-icon-contact-card' },
  { id: 165, className: 'dbc-icon dbc-icon-contact-card-link' },
  { id: 166, className: 'dbc-icon dbc-icon-document-header' },
  { id: 167, className: 'dbc-icon dbc-icon-edit' },
  { id: 168, className: 'dbc-icon dbc-icon-key' },
  { id: 169, className: 'dbc-icon dbc-icon-people-team' },
  { id: 170, className: 'dbc-icon dbc-icon-thumb-like' },
  { id: 171, className: 'dbc-icon dbc-icon-history' },
  { id: 172, className: 'dbc-icon dbc-icon-link1' },
  { id: 173, className: 'dbc-icon dbc-icon-help' },
  { id: 174, className: 'dbc-icon dbc-icon-adjustments' },
  { id: 175, className: 'dbc-icon dbc-icon-annotation' },
  { id: 176, className: 'dbc-icon dbc-icon-bookmark' },
  { id: 177, className: 'dbc-icon dbc-icon-chat-alt-2' },
  { id: 178, className: 'dbc-icon dbc-icon-cube' },
  { id: 179, className: 'dbc-icon dbc-icon-document-download' },
  { id: 180, className: 'dbc-icon dbc-icon-office-building' },
  { id: 181, className: 'dbc-icon dbc-icon-server' },
  { id: 182, className: 'dbc-icon dbc-icon-user-circle' },
  { id: 183, className: 'dbc-icon dbc-icon-view-grid-add' },
  { id: 184, className: 'dbc-icon dbc-icon-business-center' },
  { id: 185, className: 'dbc-icon dbc-icon-miscellaneous-services' },
  { id: 186, className: 'dbc-icon dbc-icon-article' },
  { id: 187, className: 'dbc-icon dbc-icon-email' },
  { id: 188, className: 'dbc-icon dbc-icon-perm-media' },
  { id: 189, className: 'dbc-icon dbc-icon-receipt' },
  { id: 190, className: 'dbc-icon dbc-icon-car-dealer' },
  { id: 191, className: 'dbc-icon dbc-icon-card-account-phone' },
  { id: 192, className: 'dbc-icon dbc-icon-card-text' },
  { id: 193, className: 'dbc-icon dbc-icon-tools' },
  { id: 194, className: 'dbc-icon dbc-icon-web' },
  { id: 195, className: 'dbc-icon dbc-icon-ph_handshake-bold' },
  { id: 196, className: 'dbc-icon dbc-icon-users-three' },
  { id: 197, className: 'dbc-icon dbc-icon-tag-price' },
  { id: 198, className: 'dbc-icon dbc-icon-smartphone-download' }

]



// WEBPACK FOOTER //
// ./scripts/src/helpers/menu.icon.helper.js